import React from 'react';
import { connect } from 'react-redux';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { useTranslation } from 'react-i18next';
import { EJRecordTypes } from '../../../common/enumerations/ej-record-types';
import { IElectronicJournalRecord } from '../../../common/interfaces/states/IElectronicJournalRecord';
import { AppState } from '../../../common/redux/configure-store';
import { SummaryMenuBase } from './summary-menu-base';

const PromotionsSummaryMenu: React.FC<IPromotionsSummaryMenuState> = (
  props: IPromotionsSummaryMenuState,
) => {
  const { t } = useTranslation();
  return (
    <SummaryMenuBase
      title={t('PromotionSummary_Heading')}
      totalLabel={t('ItemDetailsView_Savings')}
      testIdPrefix='promotions'
      {...props}
    />
  );
};

const mapStateToProps = (state: AppState): IPromotionsSummaryMenuState => ({
  items: state.itemList.ejItems.filter(
    i =>
      (i.Type === EJRecordTypes.Promotion || i.Type === EJRecordTypes.RewardAsTender) && !i.Voided,
  ),
  totalValue: convertCurrency(state.itemList.savings, state.itemList.currencyCode),
});

interface IPromotionsSummaryMenuState {
  items: IElectronicJournalRecord[];
  totalValue: string;
}

export default connect(mapStateToProps)(PromotionsSummaryMenu);
